<template>
  <div
    class="grid grid-cols-3 gap-px bg-background-fg/5 py-px"
  >
    <template
      v-for="layoutItem in layout"
      :key="layoutItem.label"
    >
      <button
        type="button"
        class="flex items-center justify-center bg-background py-3.5 text-3xl"
        @pointerdown.prevent="layoutItem.onClick"
        @contextmenu.prevent
      >
        <template v-if="layoutItem.label === 'backspace'">
          <IconBackspace class="size-6" />
        </template>

        <template v-else>
          {{ layoutItem.label }}
        </template>
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: number }>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: number): void
}>()

const handleNumberClick = (number: number) => {
  emit("update:modelValue", props.modelValue * 10 + number)
}

const handleDoubleZeroClick = () => {
  emit("update:modelValue", props.modelValue * 100)
}

const layout = [
  {
    label: "7",
    onClick: () => handleNumberClick(7),
  },
  {
    label: "8",
    onClick: () => handleNumberClick(8),
  },
  {
    label: "9",
    onClick: () => handleNumberClick(9),
  },
  {
    label: "4",
    onClick: () => handleNumberClick(4),
  },
  {
    label: "5",
    onClick: () => handleNumberClick(5),
  },
  {
    label: "6",
    onClick: () => handleNumberClick(6),
  },
  {
    label: "1",
    onClick: () => handleNumberClick(1),
  },
  {
    label: "2",
    onClick: () => handleNumberClick(2),
  },
  {
    label: "3",
    onClick: () => handleNumberClick(3),
  },
  {
    label: "backspace",
    onClick: () => handleBackspace(),
  },
  {
    label: "0",
    onClick: () => handleNumberClick(0),
  },
  {
    label: "00",
    onClick: handleDoubleZeroClick,
  },
]

const handleBackspace = () => {
  emit(
    "update:modelValue",
    Math.floor(props.modelValue / 10)
  )
}
</script>
